import { Link } from "react-router-dom";
import { CheckCircleIcon } from "./ui.js";

/**
 * Final step — the pro is in. We keep the pending-review gate, so this is an
 * honest "you're in, we're reviewing" rather than "you're live".
 */
export function DoneStep({ businessName }: { businessName: string }) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-6 py-12 text-center">
      <div className="flex justify-center text-brand-600">
        <CheckCircleIcon />
      </div>
      <h1 className="mt-6 text-3xl font-bold text-charcoal">You&rsquo;re in!</h1>
      <p className="mt-3 text-base leading-relaxed text-charcoal">
        {businessName ? <strong>{businessName}</strong> : "Your profile"} is all set. Our team gives
        every new pro a quick review — we&rsquo;ll email you the moment you&rsquo;re approved and
        start sending local job leads your way.
      </p>
      <div className="mt-8">
        <Link
          to="/portal"
          className="inline-flex min-h-[48px] w-full items-center justify-center rounded-xl bg-brand-700 px-6 text-base font-semibold text-white shadow-sm active:bg-brand-800"
        >
          Go to my portal
        </Link>
      </div>
      <p className="mt-4 text-sm text-charcoal">
        While you wait, you can fine-tune your profile anytime from the portal.
      </p>
    </main>
  );
}
